export var FormFields;
(function (FormFields) {
    FormFields["text"] = "text";
    FormFields["emoji"] = "emoji";
    FormFields["borderColor"] = "borderColor";
    FormFields["backgroundColor"] = "backgroundColor";
    FormFields["textColor"] = "textColor";
    FormFields["canBeEarnedByMembers"] = "canBeEarnedByMembers";
    FormFields["removeWhenRulesNoLongerMet"] = "removeWhenRulesNoLongerMet";
    FormFields["giveToSelectedMembers"] = "giveToSelectedMembers";
    FormFields["rules"] = "rules";
    FormFields["manuallyAssignedSupporters"] = "manuallyAssignedSupporters";
    FormFields["commentsWrittenMin"] = "commentsWrittenMin";
    FormFields["commentsWrittenMax"] = "commentsWrittenMax";
    FormFields["likesGivenMin"] = "likesGivenMin";
    FormFields["likesGivenMax"] = "likesGivenMax";
    FormFields["likesReceivedMin"] = "likesReceivedMin";
    FormFields["likesReceivedMax"] = "likesReceivedMax";
    FormFields["memberStreakBadges"] = "memberStreakBadges";
})(FormFields || (FormFields = {}));
